import { Form } from '@homex/se-react-components';
import styled from 'styled-components/macro';

import { large } from 'styles/breakpoints';
import { container, containerTall } from 'styles/layout';

export const FormGroup = styled(Form)`
  ${containerTall}
`;

export const Buttons = styled.div`
  ${container}
`;

export const Container = styled.div`
  ${container}

  margin-top: 124px;
  min-height: 161px;
  padding-right: 8px;

  ${large`
    padding-right: 0;
  `}
`;
